import { FC } from 'react';
import { Box, BoxProps } from '@mui/material';

export const ToolbarOffset: FC<Omit<BoxProps, 'sx'>> = props => (
  <Box {...props} component='span' sx={theme => theme.mixins.toolbar} />
);
